import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import AdvisoryPriceDisplay from '@stubhub/react-advisory-price-display';

export const PriceInfo = ({currency, price}) => (
  <>
    <span className="EventItem__From">
      <FormattedMessage id="EventItem.priceFrom" defaultMessage="from" />
    </span>
    <span className="EventItem__Price">
      <AdvisoryPriceDisplay currency={currency} price={price} isLoading={false} decimalPlaces={0} />
    </span>
  </>
);

PriceInfo.displayName = 'PriceInfo';
PriceInfo.propTypes = {
  /**
   * Currency code
   */
  currency: PropTypes.string.isRequired,

  /**
   * Price
   */
  price: PropTypes.number.isRequired,
};
